/**
 *  Register.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";
import { withRouter } from "react-router-dom";

// Tables
import {
  PagingState,
  IntegratedPaging,
  SearchState,
  IntegratedFiltering,
  SortingState,
  IntegratedSorting,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  Toolbar,
  TableHeaderRow,
  PagingPanel,
  SearchPanel,
} from "@devexpress/dx-react-grid-bootstrap3";

// notifications
import NotificationSystem from "react-notification-system";

// style
import { style } from "../../variables/Variables.jsx";

// global
var firebase = require("../../firebase");
var utils = require("../../utils");
const ReactDOM = require("react-dom");

class VirtualFenceList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        {
          name: "createdAt",
          title: "Criado Em",
          getCellValue: (row) => utils.dateTimeFormatter(row.createdAt),
        },
        { name: "name", title: "Nome" },
        // {name: "lat", title: "Latitude"},
        // {name: "long", title: "Longitude"},
        // {name: "radius", title: "Raio"},
        {
          name: "actions",
          title: "Ações",
          getCellValue: (row) => this.actions(row),
        },
      ],
      _notificationSystem: null,
      searchValue: "",
      sortColumns: [],
      tableColumnExtensions: [],
    };

    this.changeSearchValue = (value) => this.setState({ searchValue: value });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  onHandlePolygons = (polygons) => {
    console.log("polygons", polygons);

    console.log("polygons", polygons);

    const PolygonMapComponent =
      require("../../components/PolygonMap").default ||
      require("../../components/PolygonMap");

    // create container for modal
    const container = document.createElement("div");
    document.body.appendChild(container);

    class PolygonModal extends React.Component {
      close = () => {
        try {
          ReactDOM.unmountComponentAtNode(container);
        } catch (e) {}
        if (container.parentNode) container.parentNode.removeChild(container);
      };

      render() {
        const overlayStyle = {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        };
        const modalStyle = {
          width: "90%",
          maxWidth: "1200px",
          height: "90%",
          background: "#fff",
          borderRadius: 6,
          boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        };
        const headerStyle = {
          padding: "8px 12px",
          borderBottom: "1px solid #eee",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#f7f7f7",
        };
        const bodyStyle = {
          flex: 1,
          position: "relative",
        };
        const closeBtnStyle = {
          background: "transparent",
          border: "none",
          fontSize: 14,
          cursor: "pointer",
          padding: "6px 10px",
        };

        return (
          <div style={overlayStyle} onClick={this.close}>
            <div
              style={modalStyle}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <div style={headerStyle}>
                <strong>Visualizar Cerca</strong>
                <button style={closeBtnStyle} onClick={this.close}>
                  Fechar ×
                </button>
              </div>
              <div style={bodyStyle}>
                <PolygonMapComponent
                  initialCoordinates={polygons}
                  handlePolygonComplete={() => {}}
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ marginBottom: 60 }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                />
              </div>
            </div>
          </div>
        );
      }
    }

    ReactDOM.render(<PolygonModal initialCoordinates={polygons} />, container);
  };

  actions = (row) => {
    return (
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <a
          onClick={(e) => {
            e.stopPropagation();
            this.disable(row);
          }}
          className="link-edit"
        >
          <span className="text-danger" style={{ fontWeight: "bold" }}>
            <i className={`glyphicon glyphicon-remove`} /> DESATIVAR CERCA
          </span>
        </a>
        {/* <div
          onClick={(e) => {
            e.stopPropagation();
            this.onHandlePolygons(row.coordinates);
          }}
          style={{ cursor: "pointer", color: "blue", fontWeight: "bold" }}
        >
          Visualizar
        </div> */}
      </div>
    );
  };

  disable = (row) => {
    const { reload } = this.props;
    this.notify("Desativado com sucesso", "success");
    firebase.database
      .ref(`virtualFence/${row.key}`)
      .update({ status: 0 })
      .then((_) => {
        reload();
      });
  };

  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell" />,
      message: <div>{message}</div>,
      level: level,
      position: "tr",
      autoDismiss: 10,
    });
  };

  render() {
    const { columns, searchValue, sortColumns, tableColumnExtensions } =
      this.state;
    const { list } = this.props;

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />

        <Grid rows={list} columns={columns}>
          <SearchState
            value={searchValue}
            onValueChange={this.changeSearchValue}
          />

          <PagingState defaultCurrentPage={0} defaultPageSize={20} />

          <SortingState defaultSorting={sortColumns} />

          <IntegratedFiltering />
          <IntegratedSorting />
          <IntegratedPaging />

          <Table columnExtensions={tableColumnExtensions} />
          <TableHeaderRow showSortingControls />
          <Toolbar />

          <SearchPanel />

          <PagingPanel pageSizes={[5, 15, 20, 25, 50, 100, 0]} />
        </Grid>
      </div>
    );
  }
}

export default withRouter(VirtualFenceList);



// WEBPACK FOOTER //
// ./src/views/VirtualFence/VirtualFenceList.jsx